import React, { useEffect, useState } from "react";
import { UseAPICaller } from "../../apiCaller.tsx";
import { jsPDF } from "jspdf";
import "../../css/AppDialog.css";

import { ReportInfo} from "./FormDataTypes.tsx";

import { generatePDF } from "../GeneratePDF.tsx";

export interface AppDialogProps {
    isOpen: boolean;
    OnBackClicked: () => void;
    onDialogClose?: () => void;
    reportData: ReportInfo;
    summary:string|null;
    setSummary:(string) => void;
}


const ReportSummaryDialogContent : React.FC<AppDialogProps> = ({isOpen, OnBackClicked, onDialogClose, reportData, summary, setSummary}) => {
    
    const {GenerateSummary} = UseAPICaller();

    
    const [loading, setLoading] = useState<boolean>(false);
    const [wordCount, setWordCount] = useState<number>(400);

    ///This function is for testing the api calls to create summarys of documents using AI.
    const SummaryAPICall = async () => {
        // const company = JSON.parse(sessionStorage.getItem("company"));
        // const {companyInfo_DB, activities_db, surveys_db, responses_db} = await GetSummaryData(company.companyId, reportData.activities, reportData.surveys);
        
        // const companyInfo : CompanyInfo_AI = {
        //     questions:companyInfo_DB.questions,
        //     agendas:companyInfo_DB.agendas.map(id =>AGENDA_GOALS[id])
        // }

        // const activities : Activity_AI[] = activities_db.map(activity => {
        //     return {
        //         title: activity.title,
        //         type: activity.type,
        //         startDate: activity.startDate,
        //         endDate: activity.endDate,
        //         description: activity.description,
        //         agendas: activity.agendas.map(id => AGENDA_GOALS[id]),
        //         surveys: surveys_db.filter(s => activity.surveys.includes(s.surveyId)).map(s => s.title),
        //         attendees: activity.attendees
        //     }
        // });

        // const surveys: Survey_AI[] = surveys_db.map(survey => {
        //     // Get all responses belonging to this survey
        //     const surveyResponses = responses_db.filter(r => r.surveyId === survey.surveyId);

        //     // Flatten and group answers by questionName
        //     const questionMap: Record<string, number[]> = {};

        //     surveyResponses.forEach(r => {
        //         r.answers.forEach(a => {
        //         if (!questionMap[a.questionName]) {
        //             questionMap[a.questionName] = [];
        //         }
        //         questionMap[a.questionName].push(a.value);
        //         });
        //     });

        //     // Convert grouped object into SurveyResponse_AI[]
        //     const responses: SurveyResponse_AI[] = Object.entries(questionMap).map(
        //         ([question, answers]) => ({ question, answers })
        //     );

        //     return {
        //         title: survey.title,
        //         numberOfResponses: survey.numResponses,
        //         responses
        //     };
        //     });

        // const payload : Data_AI = {
        //     companyInfo:companyInfo,
        //     activities: activities,
        //     surveys:surveys
        // }
        
        // console.log(payload);

        setLoading(true);
        try 
        {
            // const response = await fetch("http://185.7.62.58:3001/reportsummary", {
            //     method: "POST",
            //     headers: {"content-type":"application/json"},
            //     body: JSON.stringify({text:JSON.stringify(payload), wordCount:wordCount})
            // });
            const company = JSON.parse(sessionStorage.getItem("company"));
            const response = await GenerateSummary(company.companyId, reportData.activities, reportData.surveys, wordCount);
            // console.log(response)

            if (response.summary)
            {
                setSummary(response.summary);
            }
            else
            {
                setLoading(false);
            }
        } 
        catch (error) 
        {
            setSummary("An error occurred!");
        }
        finally 
        {
            setLoading(false);
        }
    }

    const openGamma = async () => {
        await copyToClipboard(summary);
        window.open("https://gamma.app/create/paste", "_blank"); // "_blank" opens in a new tab
    };

    async function copyToClipboard(text: string) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
        } else {
            // fallback för HTTP
            const input = document.createElement('input');
            input.value = text;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        }
    }

    const downloadPDF = () => {
        const name = `${reportData.title}.pdf`;
        generatePDF({text:summary, fileName:name});
    };

    return (
        <div className="dialog-body">
            <div className="dialog-column-left">
                <div style={{display:"flex", flexDirection:"column", gap:6}}>
                    <button className={`dialog-button ${loading ? "inactive-button" : "blue-button"}`} onClick={SummaryAPICall}>Create Summary</button>
                    {/* <button className={`dialog-button ${!summary ? "inactive-button" : "blue-button"}`} onClick={downloadPDF}>Export PDF</button> */}
                    <button className={`dialog-button ${!summary ? "inactive-button" : "blue-button"}`} onClick={openGamma}>Create Presentation</button>
                    <div style={{display:"flex", flexDirection:"column"}}>
                        <label>Word Count</label>
                        <input type="number" value={wordCount} onChange={e => {setWordCount(parseInt(e.target.value))}}></input>
                    </div>
                </div>
                <div style={{marginTop:"auto"}}>
                    <button className="dialog-button blue-button" onClick={OnBackClicked}>Back</button>
                </div>
            </div>


            {loading ? (
                <div className="spinner-overlay">
                    <div className="spinner"></div>
                </div>
            )
            :
            (<div className="dialog-column-big-right">
                {summary ? 
                (<p>Text below is editable so you can edit/add/remove any text you wish.</p>):(<p>Select a word count for your summary and then press "Create Summary".</p>)}
                <textarea 
                    className="summary-text-area"
                    value={summary}
                    onChange={e => setSummary(e.target.value)}
                ></textarea>
            </div>)}
        </div>
    );
}

export default ReportSummaryDialogContent;